import React from 'react'
import { composeRefs } from 'react-behave'

export function useComposedRefs(handlers) {
  // We actually want the handlers to be the dependency list.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useMemo(() => composeRefs(handlers), handlers)
}
